import "./home.css";
import image1 from "../assets/images/image1.jpg";
import image2 from "../assets/images/image2.jpg";
import image3 from "../assets/images/image3.jpg";
import image4 from "../assets/images/image4.jpg";
import image5 from "../assets/images/image5.jpg";
import aboutUs from "../assets/images/about_us.png";
import newsbg from "../assets/images/newsbg.jpg";
import contactbg from "../assets/images/contactbg.jpg";
import logo from "../assets/images/logo.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Products } from "./Products";
import { useState } from "react";

export const Home = () => {
  const [selected, setSelected] = useState("home");
  const images = [image1, image2, image3, image4, image5];
  const settings = {
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  return (
    <div>
      <header className="header">
        <div className="header_logo">
          <img src={logo} alt="Logo"/>
          <span>ATLAS Technologies</span>
        </div>
        <nav>
          <a
            href="#home"
            onClick={() => setSelected("home")}
            className={selected === "home" ? "active" : ""}
          >
            Home
          </a>
          <a
            href="#aboutus"
            onClick={() => setSelected("aboutus")}
            className={selected === "aboutus" ? "active" : ""}
          >
            About Us
          </a>
          <a
            href="#products"
            onClick={() => setSelected("products")}
            className={selected === "products" ? "active" : ""}
          >
            Products
          </a>
          <a
            href="#contactus"
            onClick={() => setSelected("contactus")}
            className={selected === "contactus" ? "active" : ""}
          >
            Contact Us
          </a>
        </nav>
      </header>

      <div className="container">
        <div className="slider-wrapper" id="home">
          <Slider {...settings}>
            {images.map((src, index) => (
              <div key={index}>
                <img
                  src={src}
                  alt={`slide-${index + 1}`}
                  className="slider-image"
                />
              </div>
            ))}
          </Slider>
        </div>

        <Products />

        <div className="about_section" id="aboutus">
          <div>
            <h2>About US</h2>
            <div className="description">
              Atlas technologies is chennai registered proprietorship firm
              specialize in Government tenders in Tamilnad , Kerala for
              Personnel Safety , Lighting Products and services. Since its
              inception in 2007, the company has rapidly grown from a one-man
              operation into a thriving small business employing a 3 semi
              skilled people.
            </div>
          </div>
          <div>
            <img src={aboutUs} alt="about us" />
          </div>
        </div>

        <div className="contact_section" id="contactus">
          <div className="image-container">
            <img src={newsbg} alt="Background" className="background-img" />
            <div className="overlay-wrapper">
              <img src={contactbg} alt="Overlay" className="overlay-img" />
              <div className="overlay-text">
                <h1>Get in touch with us!</h1>
                <p>
                  7/1, Veethimariamman Koil, 2nd street, Jafferkhanpet, CHENNAI - 600 083
                </p>
                <p>
                  Call us: (+91) 9447030927 | E-mail:
                  atlas.technologies9@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <div>Copyright 2025</div>
          <div>RS Software Technologies</div>
        </footer>
      </div>
    </div>
  );
};
